export const socialLinks = {
    linkedin: "https://www.linkedin.com/in/sspl",
    facebook: "https://www.facebook.com/sspl10",
    instagram: "https://www.instagram.com/sspllpss",
    github: "https://github.com/samsspl",
  };
  